// Fire a Meta Pixel standard event at most once per dedupe key (no PII params).
export const trackOnce = (event, key) => {
  const storeKey = `cfx_px_${event}_${key}`;
  try {
    if (localStorage.getItem(storeKey)) return false;
    localStorage.setItem(storeKey, "1");
  } catch (e) {}
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("track", event, {}, { eventID: `${event}_${key}` });
    return true;
  }
  return false;
};
